import { classnames } from 'helpers/utils';
import styles from './input-dropdown-menu-item.module.scss';

interface InputDropdownMenuItemProps {
  className?: string;
  onClick: () => void;
  disabled?: boolean;
  leftIcon?: React.ReactNode;
  children: React.ReactNode;
  description?: string;
}

export const InputDropdownMenuItem = ({
  className,
  onClick,
  disabled,
  leftIcon,
  children,
  description,
}: InputDropdownMenuItemProps) => (
  <button
    type="button"
    className={className}
    onClick={onClick}
    disabled={disabled}
  >
    {leftIcon && <div>{leftIcon}</div>}
    <span
      className={classnames(
        styles.textEllipsis,
        'text__body__semi__bold__small__gray700',
      )}
    >
      {children}
    </span>
    {description && <span className={styles.textEllipsis}>{description}</span>}
  </button>
);
